module.exports = __webpack_public_path__ + "static/media/client3.0378ba67.svg";